import React from 'react';
import Text, { TextProps } from '../../Text';
import {
  CircularProgressBarCoreProps,
  convertToPercentageString,
} from './CircularProgressBarCore';
import { Size, sizesMap } from '../constants';

type ProgressLabelProps = Pick<
  CircularProgressBarCoreProps,
  'size' | 'value' | 'data-skin' | 'label'
>;
type CircularProgressSize = keyof typeof Size;

const labelSkinMap: Record<
  NonNullable<CircularProgressBarCoreProps['data-skin']>,
  TextProps['skin']
> = {
  standard: 'primary',
  premium: 'premium',
  success: 'success',
};

const labelSizeMap: Record<CircularProgressSize, TextProps['size']> = {
  small: undefined,
  medium: 'tiny',
  large: 'medium',
};

export const ProgressLabel: React.FC<ProgressLabelProps> = props => {
  const [reversedSize] = Object.entries(sizesMap).find(
    ([, numberSize]) => numberSize === props.size,
  ) as CircularProgressSize[];

  if (reversedSize === Size.small) {
    return <></>;
  }

  const labelSize = labelSizeMap[reversedSize];
  const labelSkin = labelSkinMap[props['data-skin']!];

  return (
    <Text skin={labelSkin} size={labelSize} weight="bold">
      {props.label || convertToPercentageString(props.value as number)}
    </Text>
  );
};
